import { render, staticRenderFns } from "./VAppTitle.vue?vue&type=template&id=271b3b1a&scoped=true&"
import script from "./VAppTitle.vue?vue&type=script&lang=js&"
export * from "./VAppTitle.vue?vue&type=script&lang=js&"
import style0 from "./VAppTitle.vue?vue&type=style&index=0&id=271b3b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b3b1a",
  null
  
)

export default component.exports